import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Learning a new field is super hard, I get it now 😅",
  "description": "",
  "published": "2019-03-11T00:00:00.000Z",
  "redirect_from": ["/blog/learning-a-new-field-is-super-hard-i-get-it-now-%f0%9f%98%85/swizec/8974"],
  "categories": "Back End, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I could never understand why people keep asking me this one stupid question. A question with an answer so obvious it made no sense why `}<em parentName="p">{`everyone kept asking`}</em>{`. EVERYONE.`}</p>
    <p><em parentName="p">{`"Hey Swiz, how do I structure my project?"`}</em></p>
    <p><em parentName="p">{`"Hey Swiz, where do I put this code?"`}</em></p>
    <p><em parentName="p">{`"Hey Swiz, do I use folders or not?"`}</em></p>
    <p><em parentName="p">{`"Hey Swiz, how many components in a file?"`}</em></p>
    <p><em parentName="p">{`"Hey Swiz, where do I put my styled components?"`}</em></p>
    <p><img parentName="p" {...{
        "src": "/6a45f18bc81da3890322801710c1ef4f/media-10o3Um2U3wa4DK-giphy.gif",
        "alt": null
      }}></img></p>
    <p><em parentName="p">{`It. Doesn't. Matter. Put your stuff wherever! When it feels untidy, tidy it up.`}</em></p>
    <p>{`I keep structure flat for small projects. When projects get big I group things in folders. Stuff that works together goes together.`}</p>
    <h2 {...{
      "id": "but-i-get-it-now-i-get-it"
    }}>{`But I get it now, I get it`}</h2>
    <p>{`But I get it now. I understand why everyone asks this.`}</p>
    <p>{`Last week I inherited a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Kotlin_(programming_language)"
      }}>{`Kotlin`}</a>{` project at dayjob.exe. I knew it was coming, I just didn't prepare :P`}</p>
    <p>{`Kotlin, by the way, is a programming language that compiles to Java bytecode. Runs on the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Java_virtual_machine"
      }}>{`JVM`}</a>{`. Often used for Android development, we're trying it for AWS Lambdas.`}</p>
    <p>{`Got tired of Ruby and its loose approach to types, don't want to write raw Java because it's meh, consider Scala to be too much of a mess. That leaves Kotlin.`}</p>
    <p>{`NodeJS with JavaScript or TypeScript got disqualified I'm not sure why. Python too.`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`The time has come for me to learn Kotlin. Because reasons`}<br parentName="p"></br><br parentName="p"></br>{`First surprise: It takes 700MB of space just to install the language. No IDE or anything.`}<br parentName="p"></br><br parentName="p"></br>{`node_modules ain't got nothing on this`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1103070682248704002"
      }}>{`March 5, 2019`}</a></blockquote>
    <h2 {...{
      "id": "so-here-i-am-trying-to-learn-kotlin"
    }}>{`So here I am trying to learn Kotlin`}</h2>
    <p>{`So here I am trying to learn Kotlin and ... ho boy it's been rough. Took me two days just to get my code to run locally.`}</p>
    <p>{`Being in a Lambda environment doesn't help.`}</p>
    <p>{`You `}<a parentName="p" {...{
        "href": "https://medium.com/@agavatar/programming-with-kotlin-in-visual-studio-code-1d745d6b4ad1"
      }}>{`install Kotlin and set up VSCode`}</a>{` with Kotlin support. I tried IntelliJ's IDEA environment. Hated how it looks, hated how clunky it felt, didn't wanna use it.`}</p>
    <p>{`I'm told using VSCode will punish me in the future. It's already missing the jump-to-definition stuff it can do in JavaScript and even Ruby.`}</p>
    <p>{`Statically typed languages like Kotlin and Java are supposed to make that feature easier to implement ... ¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`Syntax highlighting doesn't work great either. Oh well.`}</p>
    <p>{`Ok so I get that set up and after a painful run at installing Java I can run small examples right in my editor. Wonderful!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "und",
        "dir": "ltr"
      }}>{`O oh ... `}<a parentName="p" {...{
          "href": "https://t.co/nXGppnelUK"
        }}>{`pic.twitter.com/nXGppnelUK`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1103076169048420353"
      }}>{`March 5, 2019`}</a></blockquote>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Ah yes. The popup modal links you to the wrong thing, you need JDK, not JRE, whatever that is. How absolutely obvious why didn't I think of that`}<br parentName="p"></br><br parentName="p"></br>{`Thanks StackOverflow`}<a parentName="p" {...{
          "href": "https://t.co/yZ4Q1XSP2m"
        }}>{`https://t.co/yZ4Q1XSP2m`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1103078534661074944"
      }}>{`March 5, 2019`}</a></blockquote>
    <p>{`How was I supposed to know the popup gives you the wrong thing?`}</p>
    <p>{`Blogs and articles about Kotlin don't tell you this because they all assume you're coming from a Java background and have everything running. Not me :D`}</p>
    <h2 {...{
      "id": "and-then-it-gets-worse"
    }}>{`And then it gets worse`}</h2>
    <p>{`Then my instructions, from the lady who started this project, say that I have to run `}<inlineCode parentName="p">{`./gradlew`}</inlineCode>{`. Gradle is some sort of better compiler for Kotlin. Using `}<inlineCode parentName="p">{`kotlinc`}</inlineCode>{` directly is too hard?`}</p>
    <p>{`Gradle itself also isn't good enough so everyone uses gradle wrapper called `}<inlineCode parentName="p">{`gradlew`}</inlineCode>{`.`}</p>
    <p>{`It's a bit like having `}<inlineCode parentName="p">{`npm`}</inlineCode>{`. You specify dependencies and stuff in a `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{`, which is written in `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Apache_Groovy"
      }}>{`Groovy`}</a>{`, and when you run `}<inlineCode parentName="p">{`./gradlew`}</inlineCode>{` it installs dependencies then compiles your code.`}</p>
    <p>{`Oh except running `}<inlineCode parentName="p">{`gradlew`}</inlineCode>{` doesn't work because it needs a `}<inlineCode parentName="p">{`.jar`}</inlineCode>{` file that is supposed to be part of your repository. But `}<inlineCode parentName="p">{`.jar`}</inlineCode>{` files are in `}<inlineCode parentName="p">{`.gitignore`}</inlineCode>{` because obviously you don't want compiled files in your git.`}</p>
    <p>{`Jar files are the compiled result of Java programs. It's like a package with compiled code and some other stuff.`}</p>
    <p>{`I forget what I had to run, but I had to compile my compile tool before I could compile my code.`}</p>
    <p><img parentName="p" {...{
        "src": "/94218b68dd5330bc8491004066c8e177/media-3oz8xIiQkjAhhtorGU-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`And then I learned about something called `}<a parentName="p" {...{
        "href": "https://aws.amazon.com/serverless/sam/"
      }}>{`SAM – Serverless Application Model`}</a>{`. It's an Amazon tool that lets you run cloud functions locally.`}</p>
    <p>{`Except it didn't work.`}</p>
    <p>{`Complained about Docker. Don't need to set up Docker, just have it on my computer. SAM uses that to simulate lambdas ... I think.`}</p>
    <p>{`Then SAM complained about my AWS configuration. Not that it told me this, Twitter told me this after seeing my error screenshot.`}</p>
    <p>{`AWS uses local config files in `}<inlineCode parentName="p">{`~/.aws`}</inlineCode>{` to get your AWS credentials and stuff. I set those up as per my predecessor's instructions. Didn't work.`}</p>
    <p>{`Googled around and I needed some sort of `}<inlineCode parentName="p">{`awscli`}</inlineCode>{` that has a `}<inlineCode parentName="p">{`configure`}</inlineCode>{` command. Used two different ways to install, both succeeded, neither worked.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Trying to install the aws cli so I can properly configure stuff. Thanks `}<a parentName="p" {...{
          "href": "https://twitter.com/NejcRavnik"
        }}>{`@NejcRavnik`}</a>{` for the idea`}<br parentName="p"></br><br parentName="p"></br>{`Tried 2 ways to install: running a bash command and with pip3`}<br parentName="p"></br><br parentName="p"></br>{`Both succeed.`}<br parentName="p"></br>{`Neither installs aws-cli. It's literally not in the only Python path I have on my computer `}<a parentName="p" {...{
          "href": "https://t.co/m7QC2vrLON"
        }}>{`pic.twitter.com/m7QC2vrLON`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1103740088431697922"
      }}>{`March 7, 2019`}</a></blockquote>
    <p>{`Rebooting my computer made it work. No idea why. Yes I tried restarting terminal to pick up new binaries.`}</p>
    <p>{`By now it's been two days and learning Kotlin feels a lot like running through a brick wall.`}</p>
    <p><img parentName="p" {...{
        "src": "/b0bf3ff164fe54d4d41f8884a9ca4aa2/media-mIvrv5Qe0kHlu-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`But I could run my code locally 💪`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`IT LIVES `}<a parentName="p" {...{
          "href": "https://t.co/xFa2ZWjPJs"
        }}>{`pic.twitter.com/xFa2ZWjPJs`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1103759822837542912"
      }}>{`March 7, 2019`}</a></blockquote>
    <h2 {...{
      "id": "and-then--i-didnt-know-where-to-put-my-code-"
    }}>{`And then ... I didn't know where to put my code 🙈`}</h2>
    <p>{`I could run my code, I could deploy my code, I couldn't run my code in production because some Lambda wasn't giving permissions to another Lambda and it breaks.`}</p>
    <p>{`So I figured I'd start with unit tests.`}</p>
    <p>{`My predecessor didn't set that up and you want your backend code thoroughly tested. Manual QA only goes so far.`}</p>
    <p>{`I searched the internets. My results were bad.`}</p>
    <p>{`Training Google to give good results is a big part of learning a new language or technology. Takes a while. Takes a while to learn what to search for too. All the key phrases, technology names, the good websites ...`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Learning completely new tech is an eye opening experience.`}<br parentName="p"></br><br parentName="p"></br>{`I know everything about Kotlin unit testing. I know what the good libraries are, I know how to write tests in the one I picked, I even know how to configure them.`}<br parentName="p"></br><br parentName="p"></br>{`But I don't know where to put files or how to run them.`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1104170641735933952"
      }}>{`March 9, 2019`}</a></blockquote>
    <p>{`After much reading and investigating I learned of a thing called `}<a parentName="p" {...{
        "href": "https://github.com/kotlintest/kotlintest"
      }}>{`KotlinTest`}</a>{`. It's a powerful framework for testing Kotlin that supports many different styles.`}</p>
    <p>{`One of them looks like Ruby RSpec tests I'm used to. 👌`}</p>
    <p>{`KotlinTest it is!`}</p>
    <p>{`Okay ... where do I put these files? How do I run them?`}</p>
    <p>{`Every guide and blog assumed I already know this. Oh you're trying to test your Kotlin code? `}<em parentName="p">{`Obviously`}</em>{` you know how to write a valid Kotlin file, where to put it, which imports to use, and how to run it.`}</p>
    <p>{`Yeah no I had no idea.`}</p>
    <p>{`This was an example in docs:`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="kotlin">class MyTests : StringSpec({
  "length should return size of string" {
    "hello".length shouldBe 5
  }
  "startsWith should test for a prefix" {
    "world" should startWith("wor")
  }
})
`}</code></pre>
    <p>{`The file you `}<em parentName="p">{`actually`}</em>{` need to write looks like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="kotlin">package your.stuff

import io.kotlintest.specs.StringSpec
import io.kotlintest.shouldBe

class MyTests : StringSpec({
  "length should return size of string" {
    "hello".length shouldBe 5
  }
  "startsWith should test for a prefix" {
    "world" should startWith("wor")
  }
})
`}</code></pre>
    <p>{`Banged my head against that wall for an hour. Such a small thing, so hard to figure out on your own.`}</p>
    <p>{`Like, I resorted to reading KotlinTest source files to figure this out that's how bad all the guides are.`}</p>
    <p>{`And I still didn't know where to put it or how to run it.`}</p>
    <p>{`Figured that out after many more frustrating hours of banging my head through this damn brick wall. You put files in `}<inlineCode parentName="p">{`src/test/your/stuff/test.kt`}</inlineCode>{` and run them with `}<inlineCode parentName="p">{`./gradlew test`}</inlineCode>{`.`}</p>
    <p>{`After you set up a new `}<inlineCode parentName="p">{`test {}`}</inlineCode>{` area in `}<inlineCode parentName="p">{`build.gradle`}</inlineCode>{` of course. Super obvious.`}</p>
    <p>{`At least the guides told me how to configure Gradle ...`}</p>
    <h2 {...{
      "id": ""
    }}>{`😑`}</h2>
    <p>{`So yeah I get it now, I understand why video courses are so popular (you can see what's happening and where things go), I see why people ask seemingly obvious questions.`}</p>
    <p>{`Learning very new stuff is hard. Everyone assumes you have background knowledge that you don't have. `}<em parentName="p">{`sigh`}</em></p>
    <p>{`Sorry if I ever do that. Please call me out on it.`}</p>
    <p>{`Cheers, ~Swizec`}</p>
    <p>{`PS: yes it's a balance. Otherwise you might as well explain how 1+1 works in every article ... 🤔`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      